export default __webpack_public_path__ + "static/People__British_Standard-83826e7af944ba4c8303ce0cf998584f.svg";